var _rect, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSecret = function SvgSecret(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    x: 5.5,
    y: 9.5,
    stroke: "black",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15.3898 6.12463C15.4586 6.39206 15.7312 6.55305 15.9986 6.48422C16.266 6.41539 16.427 6.1428 16.3582 5.87537L15.3898 6.12463ZM8 7H8.5C8.5 5.067 10.067 3.5 12 3.5V3V2.5C9.51472 2.5 7.5 4.51472 7.5 7H8ZM8 7H7.5V9.5H8H8.5V7H8ZM12 3V3.5C13.6302 3.5 15.0012 4.61495 15.3898 6.12463L15.874 6L16.3582 5.87537C15.8587 3.9346 14.0975 2.5 12 2.5V3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14.5,
    r: 0.5,
    stroke: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSecret);
export default ForwardRef;